import React from 'react'

import { CheckCircleFilled, CheckCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'shared/ui'
import styled, { css } from 'styled-components'

export enum StatusButtonType {
  DEFAULT = 'default',
  ANNOTATION = 'annotation',
}

interface StatusButtonProps {
  status: 'open' | 'resolved'
  onStatusChange: () => void
  showTooltip?: boolean
  className?: string
  commentType?: StatusButtonType
}

export const StatusButton: React.FC<StatusButtonProps> = ({
  status,
  onStatusChange,
  showTooltip = true,
  className,
  commentType = StatusButtonType.DEFAULT,
}) => {
  const button = (
    <SStatusButton
      onClick={(e) => {
        e.stopPropagation()
        onStatusChange()
      }}
      className={`${status === 'resolved' ? 'resolved' : ''} ${className || ''}`}
      $commentType={commentType}
      data-status-button
    >
      {status === 'open' ? <CheckCircleOutlined /> : <CheckCircleFilled />}
    </SStatusButton>
  )

  if (showTooltip) {
    return (
      <Tooltip
        title={status === 'open' ? 'Mark as resolved' : 'Mark as unresolved'}
        placement="topLeft"
      >
        {button}
      </Tooltip>
    )
  }

  return button
}

const SStatusButton = styled.button<{ $commentType?: StatusButtonType }>`
  width: 25px;
  height: 25px;
  padding: 0;
  display: flex;
  background-color: transparent;
  border: 1px solid transparent;
  color: #FFFFFF;
  font-size: 16px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: none;
  cursor: pointer;
  transition: all 0.3s;
  z-index: 1;
  pointer-events: auto;
  overflow: visible;

  &:hover {
    opacity: 0.8;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 6px;
  }

  &:active {
    color: #fff !important;
    background: rgba(255, 255, 255, 0.08) !important;
  }


  ${({ $commentType }) => $commentType === StatusButtonType.DEFAULT && css`
    display: none;
  `}

  ${({ $commentType }) => $commentType === StatusButtonType.ANNOTATION && css`
    display: flex;
    width: 32px;
    height: 32px;
    font-size: 16px;
    border-radius: 4px;

    svg {
      height: 17px;
    }
  `}
` 